/**
 * @package
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class NotFoundGuard
 */
import { Guard, GuardResult } from 'vue-router-guards';
import { Route } from 'vue-router';

export class NotFoundGuard implements Guard {
  public async execute(to: Route, from: Route): Promise<GuardResult> {
    if (!to.matched.length) {
      return new GuardResult(false, from.path || '/');
    }

    return new GuardResult(true);
  }
}
